import { Salutation } from "@messaia/cdk";

export class PhoneBookPerson {
    salutation: Salutation;
    surname: string;
    givenName: string;
    heraldic: string;
    namePrefix: string;
    nameAffix: string;
    honorific: string;
    occupationalTitle: string;
}